/* eslint-disable require-unicode-regexp */
import * as Yup from 'yup'
import * as animationData from '../../assets/lotties/lottie-loader-dark.json'
import React, { useState } from 'react'
import Button from '@taglivros/oef_componentes/build/components/button'
import Input from '@taglivros/oef_componentes/build/components/input'
import Lottie from 'react-lottie'
import PropTypes from 'prop-types'
import { deliveryFeeConstants } from './constants'
import { handleCepRequest } from '../../services/cep.service'
import styled from 'styled-components'
import { useFormik } from 'formik'

const defaultOptions = {
  'animationData': animationData.default,
  'autoplay': true,
  'loop': true,
  'rendererSettings': {
    'preserveAspectRatio': 'xMidYMid slice'
  }
}

const Container = styled.div`
  width: 100%;
  form {
    h4 {
      color: #13182d;
      font-weight: bold;
      font-size: 28px;
      margin-bottom: 0.8em;
    }
    button {
      width: 100%;
      margin-top: 10px;
    }

    div#response--container {
      color: #13182d;

      .small-text {
        cursor: pointer;
        font-weight: normal;
        font-size: 14px;
        text-decoration: underline;

        &:hover {
          opacity: 0.7;
        }

        &.not-clickable {
          text-decoration: none;
          cursor: auto;
          &:hover {
            opacity: 1;
          }
        }
      }

    }
  }

`

const FeeContainer = styled.div`
  margin-top: 20px;
  div {
    color: #4e5464;

    display: flex;
    justify-content: space-between;

    padding: 10px 0;

    & + div {
      border-top: 2px solid #B2B2B2;
    }
  }
`

const EditButton = styled.button`
  display: inline-block;
  width: auto !important;
  background-color: transparent;
`

const validationSchema = Yup.object().shape( {
  'cepInput': Yup.string().matches( /[0-9]{5}-[0-9]{3}/, 'Digite um CEP Válido' )
} )

const regex = /[.\-*/()_\s]/g

const DeliveryFeeModalContent = ( { handleDeliveryFeeModal } ) => {
  const [ loading, setLoading ] = useState( false )
  const [ requestResponse, setRequestResponse ] = useState( {} )

  const handleEdit = () => {
    setRequestResponse( {} )
  }

  const formik = useFormik( {
    'initialValues': {
      'cepInput': ''
    },
    'onSubmit': values => {
      if ( requestResponse.frete ) {
        handleDeliveryFeeModal()
        return
      }
      const cep = values.cepInput.replace( regex, '' ).slice( 0, 8 )
      setLoading( true )
      handleCepRequest( cep )
        .then( ( { data } ) => {
          setRequestResponse( data )
        } )
        .catch( () => {
          formik.setErrors( { 'cepInput': deliveryFeeConstants.messages.API_ERROR } )
        } )
        .finally( () => {
          setLoading( false )
        } )
    },
    'validateOnChange': false,
    validationSchema,
  } )

  const formatCEP = ( cep ) => {
    if ( cep ) {
      return `${cep.slice( 0, 5 )}${cep.length > 5 ? '-' : ''}${cep.slice( 5, 8 )}`
    }
  }

  return (
    <Container>
      <form onSubmit={ formik.handleSubmit }>
        <h4>{deliveryFeeConstants.messages.TITLE}</h4>
        {!loading && !requestResponse.frete && (
          <Input
            erro={ formik.errors.cepInput }
            label={ deliveryFeeConstants.messages.TYPE_CEP }
            name="cepInput"
            onChange={ formik.handleChange }
            value={ formatCEP( formik.values.cepInput.replace( regex, '' ) ) }
          /> )}
        {loading && (
          <Lottie
            height={ 70 }
            options={ defaultOptions }
            width={ 100 }
          /> )}
        {!loading && requestResponse.frete && (
          <div id="response--container">
            <div>
              <span>{formik.values.cepInput}{' '}</span>
              <EditButton
                className="small-text"
                onClick={ handleEdit }
                type="button"
              >{deliveryFeeConstants.messages.EDIT}
              </EditButton>
            </div>
            <FeeContainer>
              <p className="small-text not-clickable">{deliveryFeeConstants.messages.VALUE_REGION}</p>
              { requestResponse.frete.map( ( frete ) => (
                <div key={ frete.nome }>
                  <h3>{frete.nome}</h3><h3>{frete.preco.toLocaleString( 'pt-BR', { 'currency': 'BRL', 'style': 'currency' } )}</h3>
                </div>
              ) ) }
            </FeeContainer>
          </div> )}
        <Button
          type="submit"
        >{requestResponse.frete ? deliveryFeeConstants.messages.CLOSE : deliveryFeeConstants.messages.CALCULATE}
        </Button>
      </form>

    </Container>
  )
}

DeliveryFeeModalContent.propTypes = {
  'handleDeliveryFeeModal': PropTypes.any.isRequired
}

export default DeliveryFeeModalContent
